import { createReducer, on } from '@ngrx/store';
import * as UnseenNotificationsDataActions from './actions';
import { UnseenNotificationsStateInterface } from '../types/unseen-notification-state.interface';

export const initialState: UnseenNotificationsStateInterface = {
  isLoading: false,
  unseenNotifications: null,
  error: '',
};

export const UnseenNotificationsReducers = createReducer(
  initialState,
  on(UnseenNotificationsDataActions.getUnseenNotificationsData, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    UnseenNotificationsDataActions.getUnseenNotificationsDataSuccess,
    (state, action) => ({
      ...state,
      isLoading: false,
      unseenNotifications: {
        totalNotifications: action.totalNotifications,
        notifications: action.notifications,
      },
    }),
  ),
  on(
    UnseenNotificationsDataActions.getUnseenNotificationsDataSuccessAlreadyLoaded,
    (state) => ({
      ...state,
      isLoading: false,
    }),
  ),
  on(
    UnseenNotificationsDataActions.getUnseenNotificationsDataFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
      error: action.error,
    }),
  ),
  on(
    UnseenNotificationsDataActions.removeUnseenNotifications,
    (state, action) => ({
      ...state,
      unseenNotifications: {
        totalNotifications:
          state.unseenNotifications?.totalNotifications != null
            ? state.unseenNotifications?.totalNotifications -
              action?.notificationIds?.length
            : null,
        notifications:
          state.unseenNotifications?.notifications?.filter(
            (notification) =>
              !action?.notificationIds?.includes(notification.id),
          ) ?? [],
      },
    }),
  ),

  on(UnseenNotificationsDataActions.restUnseenNotificationsData, () => ({
    ...initialState,
  })),
);
